import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";
import axios from "axios";
import getDecryptData from "../../helper/getDecryptData";

const Footer = () => {
  const { Headers, isHeader, cartItems, AllMessages, AllCategoriess } =
    useBlogContext();

        const decryptdatajson = getDecryptData();
        const myUserId = decryptdatajson?._id ?? null;
 

      const [ShowMessenger, setShowMessenger] = useState(false);

      const toggleMessenger = () => {
    setShowMessenger(prevState => !prevState); // Toggle the state
  };
 

  // Safeguard (avoid crashes if undefined)
const safeAll = Array.isArray(AllMessages) ? AllMessages : [];

// Messages addressed to me
const matchingMessages = safeAll.filter(m => m?.userId === myUserId);

// Compute last message per senderId (last occurrence wins)
const lastPerSender = new Map();
for (const msg of matchingMessages) {
  lastPerSender.set(msg.senderId, msg); // overwrite -> the last one stays
}

// Build UI order: newest senders first by walking from the end once
const seen = new Set();
const latestConversations = [];
for (let i = matchingMessages.length - 1; i >= 0; i--) {
  const m = matchingMessages[i];
  if (!seen.has(m.senderId)) {
    latestConversations.push(lastPerSender.get(m.senderId));
    seen.add(m.senderId);
  }
}

// Count = unique senders
const matchingMessageCount = latestConversations.length;


  return (
    <>
{ShowMessenger && 
 <div className="card position-fixed "  style={{
    right: 15,
    bottom: "38%",
     padding: 0,
    fontSize: 26,
    width: 200,

  }} >
    <span type="button" className="small position-absolute bg-danger d-flex justify-content-center align-items-center right-0 rounded-circle bg-dark"  style={{
    top: "-27px",
    fontSize: 14,
    width: 25,
    height: 25,
    color: "white",
    right: "-7px"
  }} onClick={toggleMessenger}> <i className="ri-close-large-line"></i> </span>
     

     <ul className="list-group border-0 overflow-auto" style={{ maxHeight: 200 }}>
  {latestConversations.map((message, index) => (
    <li key={message.senderId} className="list-group-item small">
      <Link to={`/chat/${message.senderId}`} className="d-flex">
        <img
          onError={(e) => (e.target.src = '/assets/img/profile-pic.jpg')}
          src={message.profile || '/assets/img/profile-pic.jpg'}
          className="rounded-circle me-2"
          style={{ aspectRatio: "1 / 1", objectFit: "cover", width: 50, height: 50 }}
          alt={message.username || "User"}
        />
        <div className="text-truncate">
          <span className="small text-truncate d-block">
            {message.username || "Unknown User"}
          </span>
          <span className="small text-truncate d-block text-grey" style={{ fontSize: 10 }}>
            {message.text || "No message content"}
          </span>
        </div>
      </Link>
    </li>
  ))}
</ul>


    </div>
}

{matchingMessages.length !== 0 && 

    <div  className="position-fixed rounded-circle" type="button" onClick={toggleMessenger} style={{
 
    right: 15,
    bottom: "30%",
    background: "#2573a6",
    color: "white",
    padding: 10,
    fontSize: 26,
    width: 55,
    height: 55
  }} >
   
      <i class="ri-message-3-fill"></i> <span className="small position-absolute bg-danger d-flex justify-content-center align-items-center right-0 rounded-circle" style={{top:5,fontSize:14,width:18,height:18}}>   {matchingMessageCount} </span>
    </div>
}



      {/* Footer */}
      <footer className="footer">
        <div className="footer-top py-4 py-lg-10 border-top">
          <div className="container">
          
              {isHeader
                ? // Display loading skeletons while data is being fetched
                  Array.from({ length: 12 }).map((_, index) => (
                    <div className="nav-item col-2 mb-3" key={index}>
                      <div
                        className="skeleton mt-1"
                        style={{
                          height: 22,
                          width: 100,
                          borderRadius: 5,
                        }}
                      ></div>
                    </div>
                  ))
                : Headers.footer !== undefined &&
                  Headers.footer.slice(3, 100).map((item, index) => (
                      <div className="row g-4 border-bottom mb-4 pb-2 pt-4">
                    <div className="m-0" key={index}>
                      <div className="widget widget-links">
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                            <li
                              className="breadcrumb-item active"
                              aria-current="page"
                            >
                              {" "}
                              <h4 className="widget-title mb-0 fw-medium h6 text-dark">
                                {item.text}
                              </h4>{" "}
                            </li>
                            {item.children.map((childItem, childIndex) => (
                              <li
                                key={childIndex}
                                className="breadcrumb-item pe-2"
                                aria-current="page"
                              >
                                <Link
                                  className="widget-list-link text-dark "
                                  style={{ whiteSpace: "nowrap" }}
                                  to={childItem.link}
                                >
                                  {childItem.text}
                                </Link>
                              </li>
                            ))}
                          </ol>
                        </nav>
                      </div>
                    </div>
                              </div>
                  ))}
  

            <div className="row g-4 g-lg-10">
              <div className="col-lg-9">
                <div className="row g-4">

                  
                  {isHeader
                    ? // Display loading skeletons while data is being fetched
                      Array.from({ length: 12 }).map((_, index) => (
                        <div className="nav-item col-4" key={index}>
                          <div
                            className="skeleton mt-1"
                            style={{
                              height: 22,
                              width: 100,
                              borderRadius: 5,
                            }}
                          ></div>
                        </div>
                      ))
                    : Headers.footer !== undefined &&
                      Headers.footer.slice(0, 3).map((item, index) => (
                        <div className="col px-md-4" key={index}>
                          <div className="widget widget-links">
                            <h4 className="widget-title fw-medium h6 text-dark fw-bold">
                              {item.text}
                            </h4>
                            <ul className="widget-list">
                              {item.children.map((childItem, childIndex) => (
                                <li
                                  className="widget-list-item"
                                  key={childIndex}
                                >
                                  <Link
                                    className="widget-list-link text-dark "
                                    to={childItem.link}
                                  >
                                    {childItem.text}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-4">
                  <h4 className="mb-2 h4 fw-medium h6 text-dark fw-bold">
                    CONTACT US
                  </h4>
                </div>
                <div className="mb-4">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      
                      <i className="text-dark ri-phone-fill"   style={{ fontSize: "2rem" }}
                       ></i>

                    </div>
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-0 h6 text-dark">24/7 Tech Support</h6>
                        <a
                          href={`tel:+91${Headers.phone}`}
                          className="nav-link-base h6 fw-light text-dark"
                        >
                          +91 {Headers.phone}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-4">
                  <div className="row">
                    <div className="col-auto">
                      <i
                        className="text-dark ri-map-2-fill"
                        style={{ fontSize: "2rem" }}
                      />
                    </div> 
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-1 font-weight-bold h6 text-dark">
                          Address Info
                        </h6>
                        <span className="h6 fw-light text-dark"> {Headers.address}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-4">
                  <div className="row">
                    <div className="col-auto">
                      <i
                        className="text-dark ri-mail-fill"
                        style={{ fontSize: "2rem" }}
                      />
                    </div>
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-0 h6 text-dark">24/7 Email Support</h6>
                        <a
                          href={`mailto:${Headers.email}`}
                          className="nav-link-base h6 fw-light text-dark "
                        >
                          {Headers.email}
                        </a> 
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom border-top py-4 bg-white">
          <div className="container">
            <div className="row align-items-center">
       

                     <div className="col-12 col-lg-3 text-center text-lg-start mt-3 mt-lg-0">
                     {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                    <img
                      src={Headers.meta_logo}
                      width={120}
                      alt="logo"
                      style={{
                        maxHeight: 50,
                        width: "auto",
                        filter: "grayscale(0)",
                        mixBlendMode: "multiply",
                      }}
                      className="mb-2"
                    />
                  ) : (
                    <div
                      className="card-1 skeleton"
                      style={{
                        borderRadius: 5,
                        aspectRatio: "142/25",
                        width: "100%",
                        height: 50,
                      }}
                    ></div>
                  )}
          </div>


              <div className="col-12 col-lg-6 text-center ">
             

                <p
                  title="https://seotowebdesign.com/"
                  className="nav-link-base m-0 "
                >
                  {!isHeader && Headers.footer_credit}| Design by{" "}
                  <a href="https://seotowebdesign.com/" target="blank" className="text-dark ">
                    Seo To Webdesign{" "}
                  </a>
                </p>
              </div>

           
              <div className="col-12 col-lg-3 text-center text-lg-end">
                <ul className="list-inline mb-0 gap-2 ">
                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-facebook-circle-fill"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-twitter-fill"></i>
                    </a>
                  </li>

                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-instagram-fill"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-youtube-fill"></i>
                    </a>
                  </li>
                   
                </ul>
              </div>


            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
